import styled, { css } from 'styled-components';
import { HeaderType } from '@utils/types';
import theme from '@styles/theme';

type TableRowProps = {
    LAST_CELL?: boolean;
    header: HeaderType[];
    fontColor?: string;
    bgColor?: string;
};

const TableHeader = ({
    LAST_CELL,
    header = [],
    fontColor,
    bgColor
}: TableRowProps) => {
    return (
        <TableRow $bgColor={bgColor}>
            {header.map((header: HeaderType, index: number) => {
                return (
                    <TableCell
                        key={`${index}-table-header`}
                        $minWidth={header.minWidth}
                        $width={header?.width as number}
                        $alignRight={LAST_CELL}
                        $fontColor={fontColor}
                    >
                        {header.label}
                    </TableCell>
                );
            })}
        </TableRow>
    );
};

export default TableHeader;

const TableRow = styled.div<{ $bgColor?: string }>`
    width: inherit;
    height: 50px;
    display: flex;
    align-items: center;
    font-size: 14px;
    border-bottom: 1px solid ${theme.colors.ultraLightGrayBorder};
    background-color: ${({ $bgColor }) =>
        $bgColor ? $bgColor : theme.colors.whiteColor};
`;

const TableCell = styled.div<{
    $minWidth: number;
    $width: number;
    $fontColor?: string;
    $alignRight?: boolean;
}>`
    min-width: ${({ $minWidth }) => $minWidth}px;
    width: ${({ $width, $minWidth }) =>
        $width ? `${$width}%` : `${$minWidth}px`};
    padding-left: 20px;
    font-family: 'PretendardRegular', sans-serif;
    color: ${({ $fontColor }) =>
        $fontColor ? $fontColor : theme.colors.deepGrayFontColor};

    &:last-of-type {
        padding-right: 20px;
    }

    ${({ $alignRight }) =>
        $alignRight &&
        css`
            &:last-of-type {
                text-align: right;
            }
        `}
`;
